import { apiRoot } from "../../apiRoot";
import { toast } from "react-toastify";
import { logoutAction } from "./auth";
import {
  STUDENT_PERFORMANCE_ACTION_TYPE,
  STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE,
  STUDENT_PERFORMANCE_MODAL_ACTION_TYPE,
} from "../actions-type";
import axios from "axios";

const refreshApi = axios.create({
  baseURL: `${apiRoot}/user/auth/refresh_token`,
  withCredentials: true,
});

const API = axios.create({
  baseURL: `${apiRoot}/student-performance`,

  withCredentials: true,
});

const REGISTERAPI = axios.create({
  baseURL: `${apiRoot}/user/auth`,
  withCredentials: true,
});
API.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).AccessToken
    }`;
  }

  return req;
});

REGISTERAPI.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).AccessToken
    }`;
  }

  return req;
});

const setLoadingStudentPerformanceAction = (loadingValue) => ({
  type: STUDENT_PERFORMANCE_ACTION_TYPE.STUDENT_PERFORMANCE_LAODING,
  payload: loadingValue,
});

const studentPerformanceModalLoading = (loadingValue) => ({
  type: STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_MODAL_LOADING,
  payload: loadingValue,
});

const studentPerformanceCommonModalLoading = (loadingValue) => ({
  type: STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_COMMON_MODAL_LOADING,
  payload: loadingValue,
});

const toastSuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};
const toastError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
    toastClassName: "custom-toast",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

export const getStudentPerformanceResults =
  (student, group) => async (dispatch) => {
    dispatch(setLoadingStudentPerformanceAction(true));
    try {
      const { data } = await API.get(`/${student}/${group}`);
      dispatch({
        type: STUDENT_PERFORMANCE_ACTION_TYPE.GET_STUDENT_PERFORMANCE_RESULTS,
        payload: data,
      });
      console.log(data, "Data");
    } catch (error) {
      const originalRequest = error.config;
      // // console.log(error);
      if (error?.response?.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const token = await refreshApi.get("/");
          localStorage.setItem(
            "auth",
            JSON.stringify({
              AccessToken: token?.data?.accesstoken,
            }),
          );
          const { data } = await API.get(`/${student}/${group}`);
          dispatch({
            type: STUDENT_PERFORMANCE_ACTION_TYPE.GET_STUDENT_PERFORMANCE_RESULTS,
            payload: data,
          });
        } catch (error) {
          // // console.log(error);
          if (error?.response?.status === 401) {
            return dispatch(logoutAction());
          }
        }
      }
    } finally {
      dispatch(setLoadingStudentPerformanceAction(false));
    }
  };

export const getStudentPerformanceCommonResults =
  (student, group) => async (dispatch) => {
    dispatch(setLoadingStudentPerformanceAction(true));
    try {
      const { data } = await API.get(`/common/${student}/${group}`);
      dispatch({
        type: STUDENT_PERFORMANCE_ACTION_TYPE.GET_STUDENT_PERFORMANCE_COMMON_RESULTS,
        payload: data,
      });
    } catch (error) {
      const originalRequest = error.config;
      // // console.log(error);
      if (error?.response?.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const token = await refreshApi.get("/");
          localStorage.setItem(
            "auth",
            JSON.stringify({
              AccessToken: token?.data?.accesstoken,
            }),
          );
          const { data } = await API.get(`/common/${student}/${group}`);
          dispatch({
            type: STUDENT_PERFORMANCE_ACTION_TYPE.GET_STUDENT_PERFORMANCE_COMMON_RESULTS,
            payload: data,
          });
        } catch (error) {
          // // console.log(error);
          if (error?.response?.status === 401) {
            return dispatch(logoutAction());
          }
        }
      }
    } finally {
      dispatch(setLoadingStudentPerformanceAction(false));
    }
  };

export const createStudentPerformanceResult = (result) => async (dispatch) => {
  dispatch(studentPerformanceModalLoading(true));
  try {
    const { data } = await API.post("/", result);
    dispatch({
      type: STUDENT_PERFORMANCE_ACTION_TYPE.CREATE_STUDENT_PERFORMANCE_RESULT,
      payload: data,
    });
    dispatch({
      type: STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_OPEN_MODAL,
      payload: false,
    });
    toast("Yeni nəticə yaradıldı");
  } catch (error) {
    const originalRequest = error.config;
    if (error?.response?.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const token = await refreshApi.get("/");
        localStorage.setItem(
          "auth",
          JSON.stringify({
            AccessToken: token.data.accesstoken,
          }),
        );

        await REGISTERAPI.post("/student/sign", result);

        dispatch({
          type: STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_OPEN_MODAL,
          payload: false,
        });
        toastSuccess("Yeni tələbə yaradıldı");
      } catch (error) {
        if (error?.response?.status === 401) {
          return dispatch(logoutAction());
        }
      }
    }
    console.log(error,"error")
    if (error?.response?.data?.key === "already-exists") {
      dispatch({
        type: STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_OPEN_MODAL,
        payload: true,
      });
      toastError("Bu ay artıq mövcuddur");
    }
  } finally {
    dispatch(studentPerformanceModalLoading(false));
  }
};

export const updateStudentPerformanceResult =
  (_id, result) => async (dispatch) => {
    try {
      dispatch(studentPerformanceModalLoading(true));
      const { data } = await API.patch(`/${_id}`, result);
      dispatch({
        type: STUDENT_PERFORMANCE_ACTION_TYPE.UPDATE_STUDENT_PERFORMANCE_RESULT,
        payload: data,
      });
      dispatch({
        type: STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_OPEN_MODAL,
        payload: false,
      });
      toastSuccess("Nəticə yeniləndi");
    } catch (error) {
      const originalRequest = error.config;

      if (error?.response?.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const token = await refreshApi.get("/");
          localStorage.setItem(
            "auth",
            JSON.stringify({
              AccessToken: token.data.accesstoken,
            }),
          );
          const { data } = await API.patch(`/${_id}`, result);
          dispatch({
            type: STUDENT_PERFORMANCE_ACTION_TYPE.UPDATE_STUDENT_PERFORMANCE_RESULT,
            payload: data,
          });
          dispatch({
            type: STUDENT_PERFORMANCE_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_OPEN_MODAL,
            payload: false,
          });
          toastSuccess("Nəticə yeniləndi");
        } catch (error) {
          if (error?.response?.status === 401) {
            return dispatch(logoutAction());
          }
        }
      }
    } finally {
      dispatch(studentPerformanceModalLoading(false));
    }
  };

export const updateStudentPerformanceCommonResult =
  (_id, result) => async (dispatch) => {
    try {
      dispatch(studentPerformanceCommonModalLoading(true));
      const { data } = await API.patch(`/common/${_id}`, result);
      dispatch({
        type: STUDENT_PERFORMANCE_ACTION_TYPE.UPDATE_STUDENT_PERFORMANCE_COMMON_RESULT,
        payload: data,
      });
      dispatch({
        type: STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_COMMON_OPEN_MODAL,
        payload: false,
      });
      toastSuccess("Ümumi nəticə yeniləndi");
    } catch (error) {
      const originalRequest = error.config;

      if (error?.response?.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          const token = await refreshApi.get("/");
          localStorage.setItem(
            "auth",
            JSON.stringify({
              AccessToken: token.data.accesstoken,
            }),
          );
          const { data } = await API.patch(`/common/${_id}`, result);
          dispatch({
            type: STUDENT_PERFORMANCE_ACTION_TYPE.UPDATE_STUDENT_PERFORMANCE_COMMON_RESULT,
            payload: data,
          });
          dispatch({
            type: STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE.STUDENT_PERFORMANCE_COMMON_OPEN_MODAL,
            payload: false,
          });
          toastSuccess("Ümumi nəticə yeniləndi");
        } catch (error) {
          if (error?.response?.status === 401) {
            return dispatch(logoutAction());
          }
        }
      }
    } finally {
      dispatch(studentPerformanceCommonModalLoading(false));
    }
  };

export const deleteStudentPerformanceResult = (_id) => async (dispatch) => {
  try {
    const { data } = await API.delete(`/${_id}`);

    dispatch({
      type: STUDENT_PERFORMANCE_ACTION_TYPE.DELETE_STUDENT_PERFORMANCE_RESULT,
      payload: data?.deletedData?._id,
    });
    toastSuccess("Nəticə silindi");
  } catch (error) {
    const originalRequest = error.config;
    if (error?.response?.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const token = await refreshApi.get("/");
        localStorage.setItem(
          "auth",
          JSON.stringify({
            AccessToken: token.data.accesstoken,
          }),
        );
        const { data } = await API.delete(`/${_id}`);
        dispatch({
          type: STUDENT_PERFORMANCE_ACTION_TYPE.DELETE_STUDENT_PERFORMANCE_RESULT,
          payload: data._id,
        });
        toastSuccess("Nəticə silindi");
      } catch (error) {
        if (error?.response?.status === 401) {
          return dispatch(logoutAction());
        }
      }
    }
  }
};
